<template>
  <div v-if="downloads" class="my-downloads-list">
    <h3 class="download-list--header">
      {{ t('myDownloadsTableHeading') }}
    </h3>
    <ul class="download-list">
      <li v-for="download in downloads" :key="download.createdAt" class="download-item">
        <div class="download-item--section">
          <h4 class="download-item--header">
            {{ download.name }}
          </h4>
        </div>
        <div class="download-item--section">
          <span class="download-item--label">
            {{ t('priceListRequestedAt') }}
          </span>
          <span>
            {{ formatDate(download.requestedAt) }}
          </span>
        </div>
        <div class="download-item--section">
          <span class="download-item--label">
            {{ t('priceListRequestedBy') }}
          </span>
          <span>
            {{ download.requestedBy }}
          </span>
        </div>
        <div class="download-item--section">
          <span class="download-item--label">
            {{ t('priceListStatus') }}
          </span>
          <span :class="{'download-item--error': download.statusCode === 2}">
            {{ download.statusText }}
          </span>
        </div>
        <div class="download-item--section">
          <a
            :href="download.url"
            class="download-item--download"
            :class="{'download-item--download-disable': !download.url || download.statusCode !== 1}"
            target="_blank">
            <oie-base-icon size="xs" icon="download"></oie-base-icon>
            <span class="downloads-table__download-text">{{ formatFileLabel(download.format) }}</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import myPages from '@/mixins/my-pages'
// Status codes
// Exporting = 0,
// Done = 1,
// Failed = 2,
// Expired = 3

export default {
  mixins: [myPages],
  props: {
    downloads: {
      type: Array,
      required: false,
      default: null
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    formatFileLabel(format) {
      return format === 'xlsx' ? `Excel (.${format})` : `.${format}`
    }
  }
}
</script>

<style lang="scss">
.download-list--header {
  margin-bottom: measure(quarter);
}
.download-list {
  list-style: none;
  border: 1px solid color(border-gray);
}
.download-item {
  @include media(x-small) {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    justify-content: space-between;
  }
}
.download-item:not(:last-child) {
  border-bottom: 1px solid color(border-gray);
}
.download-item--section {
  @include body-smaller;
  padding: measure(quarter);
  display: flex;
  flex-direction: column;
}
.download-item--section:not(:last-child) {
  @include media(to-small) {
    padding-bottom: unset;
  }
}
.download-item--label {
  font-weight: 600;
}
.download-item--error {
  color: color(message-error)
}
.download-item--header {
  @include body-semi-bold;
}
.download-item--download {
  @include media(x-small) {
    align-self: end;
  }
  display: flex;
  gap: measure(quarter);
  align-items: center;
}
.download-item--download-disable {
  pointer-events: none;
  opacity: 0.5;
}
</style>
